import { useEffect }from "react";

/**
 * Inspired from use-onclickoutside library, this is a custom hook created to use across Marvel which will detect
 * clicks from the React DOM and empower the component using it to perform any action(s) based on it.
 * @param ref
 * @param handler
 */
export default function useOnClickOutside(ref, handler) {
    useEffect(
        () => {
            const listener = (event) => {
                // Do nothing if clicking ref's element or descendent elements
                if (!ref.current || ref.current.contains(event.target)) {
                    return;
                }
                handler(event);
            };
            document.addEventListener("mousedown", listener);
            document.addEventListener("touchstart", listener);
            return () => {
                document.removeEventListener("mousedown", listener);
                document.removeEventListener("touchstart", listener);
            };
        },
        [ref, handler]
    );
}
